import {createSelector} from 'reselect';

import {getAnalyticsPanel} from '../analyticsPanelSelectors';
import {getAnalyticsSelectedViewId} from '../parameters/analyticsPanelParametersSelectors';
import {AnalyticsSelectedViewId} from './analyticsPanelViewsState';

export const getAnalyticsViews = createSelector(getAnalyticsPanel, ({views}) => views);

// Will only return the saved views
export const getAnalyticsSavedViews = createSelector(getAnalyticsViews, ({savedViews}) => savedViews);

// Will only return the temporary views
export const getAnalyticsTemporaryViews = createSelector(
  getAnalyticsViews,
  ({temporaryViews}) => temporaryViews,
);
export const getAnalyticsNbTemporaryViews = createSelector(
  getAnalyticsViews,
  ({nbTemporaryViews}) => nbTemporaryViews,
);

// Will return first the existing saved views and then the temporary views
export const getAnalyticsAllViews = createSelector(getAnalyticsViews, ({savedViews, temporaryViews}) => [
  ...savedViews,
  ...temporaryViews,
]);

export const makeGetSelectedView = (viewId: AnalyticsSelectedViewId) =>
  createSelector(getAnalyticsAllViews, (savedViews) => {
    const selectedView = savedViews.find((view) => view.id === viewId);
    return selectedView;
  });

export const getAnalyticsSelectedView = createSelector(
  [getAnalyticsSelectedViewId, getAnalyticsSavedViews],
  (viewId, savedViews) => savedViews.find((view) => view.id === viewId),
);

export const getAnalyticsSelectedViewFilters = createSelector(
  getAnalyticsSelectedView,
  (selectedView) => selectedView?.filters,
);

export const getAnalyticsSelectedViewFiltersOptions = createSelector(
  getAnalyticsSelectedViewFilters,
  (filters) => filters?.options,
);

export const getAnalyticsViewsAllTagNames = createSelector(getAnalyticsSavedViews, (savedViews) =>
  savedViews.map(({metadata}) => metadata.tags).reduce((acc, tags) => ({...acc, ...tags}), {}),
);

export const getAnalyticsViewsAllTags = createSelector(getAnalyticsSavedViews, (savedViews) =>
  savedViews.map(({metadata}) => metadata.fullTags).reduce((acc, fullTags) => ({...acc, ...fullTags}), {}),
);

export const getAnalyticsViewsAllInboxes = createSelector(getAnalyticsSavedViews, (savedViews) =>
  savedViews.map(({metadata}) => metadata.inboxes).reduce((acc, inboxes) => ({...acc, ...inboxes}), {}),
);

export const getAnalyticsViewsAllAccounts = createSelector(getAnalyticsSavedViews, (savedViews) =>
  savedViews.map(({metadata}) => metadata.accounts).reduce((acc, accounts) => ({...acc, ...accounts}), {}),
);

export const getAnalyticsViewError = createSelector(getAnalyticsViews, ({error}) => error);
